import { Button } from '@ui/themed';
import { t } from 'i18next';
import { showIntercom } from '../../../lib/intercom';
import { PARTNERS_I18N } from '../constants';

const PAGE = PARTNERS_I18N.page;

/**
 * Waitlist CTA shown in place of the toggle for partners still in closed beta.
 *
 * The `intercom-accountancy-waitlist` class is what Intercom binds the waitlist flow to, so it has
 * to reach the rendered button — hence passing it through `className`. Opening the messenger is the
 * whole action — deliberately no navigation, which would unmount the page before the messenger
 * settles.
 */
export function PartnerBetaWaitlist() {
  return (
    <div className="hidden flex-col items-end pl-6 text-right lg:flex">
      <div className="-mb-0.5 flex items-center text-gray-500 text-xs">
        {t(`${PAGE}.beta.join`)}
      </div>
      <Button
        variant="bare"
        size="xs"
        icon="externalLink"
        className="intercom-accountancy-waitlist"
        onClick={showIntercom}
      >
        {t(`${PAGE}.beta.sign_up`)}
      </Button>
    </div>
  );
}
